import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import ReCAPTCHA from 'react-google-recaptcha';
import { shades } from "../../../../theme.js";

const CaptchaSection = ({
  loading,
  error,
  onRecaptchaChange,
  successMessage,
  isCaptchaVerified,
  sitekey,
  recaptchaRef
}) => {
  const handleOnChange = (token) => {
    if (onRecaptchaChange) {
      onRecaptchaChange(token);
    }
  };

  const handleOnExpired = () => {
    if (onRecaptchaChange) {
      onRecaptchaChange(null);
    }
  }

  return (
    <Box
      sx={{
        borderRadius: '8px',
        p: 1,
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        backgroundColor: 'white',
        maxWidth: '100%',
      }}
    >
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
          <CircularProgress size={30} sx={{ color: shades.neutral[500] }} />
        </Box>
      ) : (
        <ReCAPTCHA
          ref={recaptchaRef}
          sitekey={sitekey}
          onChange={handleOnChange}
          onExpired={handleOnExpired}
        />
      )}

      {error && (
        <Typography
          variant="caption"
          sx={{ color: 'red', mt: 1 }}
        >
          {error}
        </Typography>
      )}

      {isCaptchaVerified && successMessage && (
        <Typography
          variant="caption"
          sx={{ color: 'green', mt: 1 }}
        >
          {successMessage}
        </Typography>
      )}
    </Box>
  );
};

export default CaptchaSection;